/**
 * Anzeigelogik der Wirtschaft im HUD.
 *
 * Hier wird nur entschieden, WAS angezeigt wird - gerechnet und entschieden
 * wird ausschliesslich auf dem Server.
 *
 * Die Regeln stehen bewusst ausserhalb der Oberflaeche, damit sie ohne Browser
 * pruefbar sind.
 */

import { getSecondsUntilNextIncomeTick, isBattlePhase } from '@dueline/game-rules';
import type { MatchPhase } from '@dueline/shared';

/**
 * Sekunden bis zum naechsten Income-Tick, aufgerundet.
 * null, solange nicht gekaempft wird - dann laeuft auch kein Income.
 */
export function getIncomeCountdown(phase: string, elapsedSeconds: number): number | null {
  if (!isBattlePhase(phase as MatchPhase)) return null;
  return Math.ceil(getSecondsUntilNextIncomeTick(elapsedSeconds));
}

/**
 * Restliche Wartezeit bis zur naechsten Welle, aufgerundet auf Sekunden.
 *
 * null, solange kein Kampf laeuft - genau wie beim Income-Tick. 0 heisst
 * "jetzt" und wird in der Leiste als eigener Zustand gezeigt.
 *
 * Warum das hier und nicht in der Anzeige steht: Dieselbe Regel gilt fuer
 * beide Uhren in der Leiste, und so ist sie geprueft.
 */
export function getWaveCooldown(phase: string, waveCooldown: number): number | null {
  if (!isBattlePhase(phase as MatchPhase)) return null;
  return Math.max(0, Math.ceil(waveCooldown));
}

/** Tier als roemische Zahl, wie im Spiel ueblich: 1 -> I. */
export function formatTier(tier: number): string {
  return ['I', 'II', 'III', 'IV'][tier - 1] ?? String(tier);
}

/**
 * Jede Zahl mit Tausendertrennung - und zwar ENGLISCH: 12500 -> 12,500.
 *
 * Die eine Stelle im ganzen Client (16.10.2026). Vorher gab es zwei, und
 * die zweite schrieb "Gold earned 1.632" mit Punkt, mitten in einer
 * englischen Oberflaeche. Aufgefallen ist es der Grafiksitzung.
 *
 * Die Sprache steht ausdruecklich dabei und wird nie weggelassen: Ohne
 * Angabe nimmt der Browser die Sprache des GERAETS. Dieselbe Fassung
 * schriebe dann auf einem deutschen Handy 1.632 und auf einem englischen
 * 1,632 - derselbe Fehler, nur schwerer zu finden. Das Spiel ist englisch
 * (Produktentscheidung vom 28.09.2026), also immer englisch, egal wo es
 * laeuft.
 *
 * Dass es bei dieser einen Stelle bleibt, haelt ein Test fest:
 * economyView.test.ts, "Tausendertrennung".
 */
export function formatZahl(wert: number): string {
  return Math.round(wert).toLocaleString('en-US');
}

/** Gold: wie jede Zahl, aber nie unter null und immer abgerundet. */
export function formatGold(gold: number): string {
  return formatZahl(Math.max(0, Math.floor(gold)));
}
